module.exports = __webpack_public_path__ + "assets/img/banner-3.0ec48ae5.png";